import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useBienContext } from '../BienContext'

import { PlusIcon } from '@heroicons/react/24/outline'
import DetailTemplate from '@/components/DetailTemplate'
import { Pagination } from '@/components/ui'
import {
  cancelNewPrestataireCreation,
  emptyEntretien,
  fetchEntretiens,
  setEntretienInEdition,
  resetEntretienInEdition,
  setFilters
} from '../../entretiens/entretiensSlice'
import Form from './Form'
import EntretienItem from './EntretienItem'


export default () => {
  const dispatch = useDispatch()
  const { bien,
    updatedSections, markSectionAsUpdated,
  } = useBienContext()
  const entretiens = useSelector(state => state.entretiens.items)
  const filters = useSelector((state) => state.entretiens.filters)
  const pagination = useSelector((state) => state.entretiens.pagination)
  const isLoading = useSelector( state => state.entretiens.loadingStatus.fetchList )

  const isCreatingNewPrestataire = useSelector( state => state.entretiens.isCreatingNewPrestataire)

  const SECTION_ID = 'entretiens'
  const SECTION_TITLE = 'Historique des entretiens'

  useEffect(
    () => {
      if(bien?.id) {
        dispatch(fetchEntretiens({bien_id: bien.id}))
      }
    },
    [ bien.id ]
  )

  useEffect(() => {
    if(filters.page != pagination.currentPage) {
      const queryFilters = { ...filters, bien_id: bien.id}
      dispatch(fetchEntretiens(queryFilters))
    }
  }, [dispatch, filters])

  const handlePageChange = (page) => {
    dispatch(setFilters({ page }))
  } 

  const AddNewEntretienButton = ({onEditClick}) => {
  
    const handleClick = async (event) => {
      event.preventDefault()
      event.stopPropagation()
      dispatch(setEntretienInEdition(emptyEntretien))
      onEditClick()
    }
  
    return (
      <div>
        <button 
          className="btn btn-sm btn-primary"
          title="Ajouter un nouvel entretien au bien"
          onClick={handleClick}
        >
          <PlusIcon className="h-5 w-5 mr-1"/> Ajouter un entretien
        </button>
      </div>
    )
  }

  const closeModalCallback = () => {
    if(isCreatingNewPrestataire) {
      dispatch(cancelNewPrestataireCreation())
    }
    dispatch(resetEntretienInEdition())
  }

  return (
    <DetailTemplate
      sectionId={SECTION_ID}
      title={SECTION_TITLE}
      bodyProps={{columns: 1, bgColor: 'white', className: 'p-0'}}
      updatedSections={updatedSections}
      loading={isLoading}
      isPendingAction={isLoading}
      editButton={<AddNewEntretienButton />}
      modalContent={<Form />}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div>
        <table className="table table-zebra w-full">
          <thead>
            <tr>
              <th>Type d'entretien</th>
              <th>Nom du prestataire</th>
              <th>Date d'entretien</th>
              <th>Montant</th>
              <th>Entité à facturer</th>
              <th>Statut de la facture</th>
            </tr>
          </thead>
          <tbody>
            { entretiens?.length == 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-4 text-gray-600 italic">
                  Aucun entretien
                </td>
              </tr>
            ) : (
              entretiens.map((entretien, index) =>(
                <EntretienItem key={index} item={entretien}/>
              ))
            )}
          </tbody>
        </table>
        { pagination.totalPages > 1 && (
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </DetailTemplate>
  )
}